import React, { useEffect, useState } from 'react';
import IconPresenter from 'hooks/IconPresenter';
import { IIconPromise } from 'types/interfaces';
import Image from 'components/commons/image/Image';

function IconPromise(props: IIconPromise) {
  const [src, setSrc] = useState() as any;
  const iconPresenter = IconPresenter();
  const { idIcon } = props;
  useEffect(() => {
    if(idIcon) {
      const getIcon = async () => {
        const icono = await iconPresenter.getIcon(props.idIcon);
        setSrc(icono);
      };
      getIcon();
    }
  }, [idIcon]);
  return (
    src && (
      <Image
        className={props.className}
        style={props.style}
        src={src}
        ariaLabel={props.alt ?? 'SRC_' + props.idIcon}
        alt={props.alt ?? 'SRC_' + props.idIcon}
        loading='lazy'
      />
    )
  );
}

export default React.memo(IconPromise);
